import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Input, Button, Table, Modal, Tabs,
	message, Alert, Tag, Form, Avatar, Tooltip, Typography, Divider,
	Pagination,
} from 'antd';
import {
	PlusOutlined, FormOutlined, CloseSquareOutlined,
	ExclamationCircleOutlined, RedoOutlined, UserOutlined,
	CheckCircleOutlined, UndoOutlined,
	PhoneOutlined, BankOutlined, TeamOutlined, KeyOutlined,
	SafetyOutlined, SearchOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;
const { TabPane } = Tabs;

const configClass = {
	title: 'Data Pegawai',
	apiUrl: { data: 'pegawai/api/pegawai/' },
	pageUrl: { form: '/admin/pegawai/form/' },
	breadCrumb: [
		<span><UserOutlined /> Pegawai</span>,
		'Daftar Pegawai',
	],
};

const config = new Config();

const LEVEL_MAP = {
	1: { label: 'Superadmin', color: '#f5222d', bg: '#fff1f0' },
	2: { label: 'Admin',      color: '#1890ff', bg: '#e6f7ff' },
	3: { label: 'User',       color: '#52c41a', bg: '#f6ffed' },
};

class DataPegawai extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			errMsg: '',
			errTitle: '',
			loadingData: false,
			loadingButton: false,
			pagination: { pageSize: 25, current: 1, total: 0 },
			searchText: '',
			dataSource: [],
			isModalVisible: false,
			id_pegawai: '',
			isMobile: window.innerWidth <= 768,
			// Pegawai TIDAK PERNAH benar-benar dihapus (soft-delete, lihat
			// be/pegawai/models.py Pegawai.delete()) - tab "Nonaktif" terpisah
			// dari "Aktif" sesuai keputusan produk (bukan 1 list gabungan
			// dgn status tag, spt pola DataTipe.jsx).
			activeTab: 'aktif',
		};
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this.getData();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	_inisial(nama) {
		if (!nama) return '?';
		return nama.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();
	}

	showDeleteConfirm(id) {
		Modal.confirm({
			title: 'Nonaktifkan Pegawai',
			icon: <ExclamationCircleOutlined />,
			content: 'Data pegawai akan dinonaktifkan beserta akun loginnya (tidak bisa dipakai login lagi) - data TIDAK dihapus permanen, bisa diaktifkan kembali lewat tab "Nonaktif".',
			okText: 'Nonaktifkan',
			okType: 'danger',
			cancelText: 'Batal',
			onOk: () => this.prosesHapus(id),
		});
	}

	showRestoreConfirm(id) {
		Modal.confirm({
			title: 'Aktifkan Kembali Pegawai',
			icon: <ExclamationCircleOutlined />,
			content: 'Data pegawai dan akun loginnya akan diaktifkan kembali seperti semula.',
			okText: 'Aktifkan',
			cancelText: 'Batal',
			onOk: () => this.prosesRestore(id),
		});
	}

	prosesRestore(id) {
		message.loading({ content: 'Mengaktifkan...', key: 'toast' });
		this.props.ajaxHandler('post', configClass.apiUrl.data + id + '/restore/', {}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Pegawai berhasil diaktifkan kembali', duration: 2, key: 'toast' });
					this.getData();
				} else {
					message.error({ content: 'Gagal mengaktifkan pegawai', duration: 2, key: 'toast' });
					this.setState({ errTitle: 'Gagal', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => message.error({ content: 'Kesalahan pengiriman data', duration: 2, key: 'toast' }));
	}

	handleTabChange = (key) => {
		this.setState(prev => ({
			activeTab: key,
			pagination: { ...prev.pagination, current: 1 },
		}), () => this.getData(this.state.pagination.pageSize, 0, this.state.searchText));
	};

	showModalReset(id) {
		this.setState({ id_pegawai: id, isModalVisible: true });
	}

	prosesHapus(id) {
		message.loading({ content: 'Menghapus...', key: 'toast' });
		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				this.setState({ loadingButton: false });
				if (this.props.isSuccess) {
					message.success({ content: 'Data berhasil dihapus', duration: 2, key: 'toast' });
					this.getData();
				} else {
					message.error({ content: 'Gagal menghapus data', duration: 2, key: 'toast' });
					this.setState({ errTitle: 'Gagal menghapus', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan pengiriman data', duration: 2, key: 'toast' });
			});
	}

	handleSubmit = (values) => { this.postPwd(values); };

	async postPwd(datas) {
		message.loading({ content: 'Menyimpan...', key: 'toast' });
		this.props.ajaxHandler('post', configClass.apiUrl.data + this.state.id_pegawai + '/set_password/', datas, false, true)
			.then(() => {
				this.setState({ loadingButton: false });
				if (this.props.isSuccess) {
					this.setState({ isModalVisible: false });
					message.success({ content: 'Password berhasil direset', duration: 2, key: 'toast' });
				} else {
					message.error({ content: 'Gagal reset password', duration: 2, key: 'toast' });
					this.setState({ errTitle: 'Gagal', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan pengiriman data', duration: 2, key: 'toast' });
			});
	}

	async getData(limit = this.state.pagination.pageSize, offset = 0, search = this.state.searchText) {
		this.setState({ loadingData: true });
		const status = this.state.activeTab === 'nonaktif' ? 'nonaktif' : 'aktif';
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + '?limit=' + limit + '&offset=' + offset + '&search=' + search + '&status=' + status)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					this.setState(prev => ({
						dataSource: data.results,
						pagination: { ...prev.pagination, total: data.count },
					}));
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => {
			this.setState(prev => ({ pagination: { ...prev.pagination, current: 1 } }));
			this.getData(this.state.pagination.pageSize, 0, val);
		}, 400);
	};

	handleTableChange = (pagination) => {
		const newPagination = {
			...this.state.pagination,
			pageSize: pagination.pageSize,
			current: pagination.current,
		};
		this.setState({ pagination: newPagination });
		this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize);
	};

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize);
	};

	// ─── Tombol Aksi ──────────────────────────────────────────────────────────
	_renderAksi(row) {
		if (this.state.activeTab === 'nonaktif') {
			return (
				<Tooltip title="Aktifkan Kembali">
					<Button
						size="small"
						shape="circle"
						style={{ borderColor: '#389e0d', color: '#389e0d' }}
						onClick={() => this.showRestoreConfirm(row.id)}
					>
						<UndoOutlined />
					</Button>
				</Tooltip>
			);
		}
		return (
			<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
				<Tooltip title="Reset Password">
					<Button
						size="small"
						shape="circle"
						style={{ borderColor: '#faad14', color: '#faad14' }}
						onClick={() => this.showModalReset(row.id)}
					>
						<KeyOutlined />
					</Button>
				</Tooltip>
				<Tooltip title="Edit">
					<Link to={configClass.pageUrl.form + row.id}>
						<Button size="small" shape="circle" type="primary" ghost>
							<FormOutlined />
						</Button>
					</Link>
				</Tooltip>
				<Tooltip title="Hapus">
					<Button
						size="small"
						shape="circle"
						danger
						onClick={() => this.showDeleteConfirm(row.id)}
					>
						<CloseSquareOutlined />
					</Button>
				</Tooltip>
			</div>
		);
	}

	// ─── Mobile Card ──────────────────────────────────────────────────────────
	renderMobileCard(row) {
		const level = LEVEL_MAP[row.level_user] || LEVEL_MAP[3];
		return (
			<Card
				key={row.id}
				style={{
					borderRadius: 14,
					marginBottom: 12,
					boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
					border: '1px solid #f0f0f0',
					overflow: 'hidden',
				}}
				bodyStyle={{ padding: 0 }}
			>
				{/* Header card */}
				<div style={{
					background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
					borderBottom: '1px solid #f0f0f0',
					padding: '12px 16px',
					display: 'flex', alignItems: 'center', gap: 12,
				}}>
					<Avatar
						size={44}
						style={{
							background: `linear-gradient(135deg, ${level.color}, ${level.color}bb)`,
							fontWeight: 700, fontSize: 16, flexShrink: 0,
						}}
					>
						{this._inisial(row.nama)}
					</Avatar>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 15, color: '#222', lineHeight: 1.3 }}>
							{row.nama}
						</div>
						<div style={{ display: 'flex', gap: 6, marginTop: 4, flexWrap: 'wrap' }}>
							<Tag
								style={{
									borderRadius: 20, fontSize: 11, margin: 0,
									background: level.bg, borderColor: level.color, color: level.color,
								}}
							>
								{level.label}
							</Tag>
							{row.is_notice && <Tag color="green" style={{ borderRadius: 20, fontSize: 11, margin: 0 }}>Notice</Tag>}
							{row.is_pns
								? <Tag color="blue" style={{ borderRadius: 20, fontSize: 11, margin: 0 }}>PNS</Tag>
								: <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0 }}>Non-PNS</Tag>
							}
						</div>
					</div>
				</div>

				{/* Info rows */}
				<div style={{ padding: '10px 16px' }}>
					{[
						{ icon: <SafetyOutlined />, label: 'Jabatan', value: row.jabatan_nama || '—' },
						{ icon: <BankOutlined />,   label: 'UPT',     value: row.upt_nama     || '—' },
						{ icon: <PhoneOutlined />,  label: 'No. HP',  value: row.no_hp        || '—' },
						{ icon: <TeamOutlined />,   label: 'Bidang',  value: row.bidang_nama  || '—' },
					].map(item => (
						<div key={item.label} style={{
							display: 'flex', gap: 8, alignItems: 'center',
							padding: '5px 0',
							borderBottom: '1px solid #f5f5f5',
						}}>
							<span style={{ color: '#1890ff', fontSize: 13, flexShrink: 0, width: 16 }}>{item.icon}</span>
							<Text type="secondary" style={{ fontSize: 12, flexShrink: 0, minWidth: 52 }}>{item.label}</Text>
							<Text style={{ fontSize: 13, fontWeight: 500 }}>{item.value}</Text>
						</div>
					))}
				</div>

				{/* Footer aksi */}
				<div style={{
					padding: '10px 16px',
					borderTop: '1px solid #f0f0f0',
					display: 'flex', gap: 8,
				}}>
					{this.state.activeTab === 'nonaktif' ? (
						<Button
							size="small"
							icon={<UndoOutlined />}
							style={{ flex: 1, borderColor: '#389e0d', color: '#389e0d' }}
							onClick={() => this.showRestoreConfirm(row.id)}
						>
							Aktifkan Kembali
						</Button>
					) : (
						<>
							<Button
								size="small"
								icon={<KeyOutlined />}
								style={{ flex: 1, borderColor: '#faad14', color: '#faad14' }}
								onClick={() => this.showModalReset(row.id)}
							>
								Reset PW
							</Button>
							<Link to={configClass.pageUrl.form + row.id} style={{ flex: 1 }}>
								<Button size="small" type="primary" ghost icon={<FormOutlined />} style={{ width: '100%' }}>
									Edit
								</Button>
							</Link>
							<Button
								size="small"
								danger
								icon={<CloseSquareOutlined />}
								style={{ flex: 1 }}
								onClick={() => this.showDeleteConfirm(row.id)}
							>
								Hapus
							</Button>
						</>
					)}
				</div>
			</Card>
		);
	}

	// ─── Kolom tabel desktop ──────────────────────────────────────────────────
	_buildColumns() {
		return [
			{
				title: 'Pegawai',
				dataIndex: 'nama',
				key: 'nama',
				width: 220,
				render: (value, row) => (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						<Avatar
							size={36}
							src={row.foto || null}
							style={{
								background: `linear-gradient(135deg, ${(LEVEL_MAP[row.level_user] || LEVEL_MAP[3]).color}, #722ed1)`,
								fontWeight: 700, fontSize: 14, flexShrink: 0,
							}}
						>
							{!row.foto && this._inisial(value)}
						</Avatar>
						<div>
							<div style={{ fontWeight: 600, fontSize: 13, color: '#222', lineHeight: 1.3 }}>{value}</div>
							{row.is_notice && <Tag color="green" style={{ borderRadius: 20, fontSize: 10, margin: '2px 0 0', padding: '0 6px', lineHeight: '16px' }}>Notice</Tag>}
						</div>
					</div>
				),
			},
			{
				title: 'NIP',
				dataIndex: 'nip',
				key: 'nip',
				width: 130,
				render: (val) => <Text style={{ fontSize: 12, color: '#555' }}>{val || '—'}</Text>,
			},
			{
				title: 'Status',
				dataIndex: 'is_pns',
				key: 'is_pns',
				width: 90,
				render: (val) => val
					? <Tag color="blue" style={{ borderRadius: 20 }}>PNS</Tag>
					: <Tag style={{ borderRadius: 20 }}>Non-PNS</Tag>,
			},
			{
				title: 'Jabatan',
				dataIndex: 'jabatan_nama',
				key: 'jabatan_nama',
				width: 160,
				ellipsis: true,
				render: (val) => val || '—',
			},
			{
				title: 'Bidang',
				dataIndex: 'bidang_nama',
				key: 'bidang_nama',
				width: 140,
				ellipsis: true,
				render: (val) => val || '—',
			},
			{
				title: 'UPT',
				dataIndex: 'upt_nama',
				key: 'upt_nama',
				width: 150,
				ellipsis: true,
				render: (val) => val || '—',
			},
			{
				title: 'No. HP',
				dataIndex: 'no_hp',
				key: 'no_hp',
				width: 130,
				render: (val) => <Text style={{ fontSize: 12, color: '#555' }}>{val || '—'}</Text>,
			},
			{
				title: 'Level',
				dataIndex: 'level_user',
				key: 'level_user',
				width: 110,
				render: (val) => {
					const lv = LEVEL_MAP[val] || LEVEL_MAP[3];
					return (
						<Tag
							style={{
								borderRadius: 20, fontWeight: 600,
								background: lv.bg, borderColor: lv.color, color: lv.color,
							}}
						>
							{lv.label}
						</Tag>
					);
				},
			},
			{
				title: 'Aksi',
				key: 'aksi',
				width: 110,
				fixed: 'right',
				render: (_, row) => this._renderAksi(row),
			},
		];
	}

	render() {
		const { errMsg, errTitle, loadingData, dataSource, pagination, isModalVisible, isMobile, activeTab } = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.data-pegawai-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700;
							font-size: 13px;
							color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.data-pegawai-wrap .ant-table-tbody > tr > td {
							padding: 12px 16px;
							vertical-align: middle;
						}
						.data-pegawai-wrap .ant-table-tbody > tr:hover > td {
							background: #e8f0fb !important;
						}
						.data-pegawai-wrap .ant-table-tbody > tr:nth-child(even) > td {
							background: #fafafa;
						}
						.data-pegawai-wrap .ant-table-tbody > tr:nth-child(even):hover > td {
							background: #e8f0fb !important;
						}
						.data-pegawai-wrap .ant-table-cell,
						.data-pegawai-wrap .ant-table-cell * {
							text-transform: none !important;
						}
						.data-pegawai-wrap .ant-input,
						.data-pegawai-wrap .ant-input-affix-wrapper input {
							text-transform: none !important;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Card
					className="data-pegawai-wrap"
					style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
					bodyStyle={{ padding: 0 }}
				>
					{/* ── Header card ── */}
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<UserOutlined style={{ marginRight: 8 }} />
								{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Total {pagination.total || 0} pegawai
								{loadingData && ' · Memuat...'}
							</div>
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Tooltip title="Refresh data">
								<Button
									onClick={() => {
										this.setState(prev => ({
											searchText: '',
											pagination: { ...prev.pagination, current: 1 },
										}), () => this.getData(this.state.pagination.pageSize, 0, ''));
									}}
									icon={<RedoOutlined />}
									style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								>
									Refresh
								</Button>
							</Tooltip>
							<Link to={configClass.pageUrl.form}>
								<Button
									type="primary"
									icon={<PlusOutlined />}
									style={{
										borderRadius: 8,
										background: '#fff',
										color: '#0f2847',
										border: 'none',
										fontWeight: 600,
									}}
								>
									Tambah Pegawai
								</Button>
							</Link>
						</div>
					</div>

					{/* ── Tab Aktif/Nonaktif - Pegawai soft-delete, dipisah dari list
					    aktif sesuai keputusan produk (bukan 1 list gabungan) ── */}
					<div style={{ padding: '8px 20px 0', background: '#fff' }}>
						<Tabs activeKey={activeTab} onChange={this.handleTabChange}>
							<TabPane tab="Aktif" key="aktif" />
							<TabPane tab="Nonaktif" key="nonaktif" />
						</Tabs>
					</div>

					{/* ── Search bar ── */}
					<div style={{ padding: '12px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff' }}>
						<Input
							placeholder="Cari nama, jabatan, atau kabupaten..."
							allowClear
							size="large"
							prefix={<SearchOutlined style={{ color: '#bbb' }} />}
							style={{ borderRadius: 8, maxWidth: 460 }}
							value={this.state.searchText}
							onChange={this.handleSearchChange}
							onClear={() => {
								this.setState({ searchText: '', pagination: { ...this.state.pagination, current: 1 } },
									() => this.getData(this.state.pagination.pageSize, 0, ''));
							}}
						/>
					</div>

					{/* ── Konten: tabel atau card list ── */}
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							// ── Mobile: card list ──
							<div>
								{loadingData ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div>
								) : dataSource.length === 0 ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Tidak ada data</div>
								) : (
									dataSource.map(row => this.renderMobileCard(row))
								)}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current}
											pageSize={pagination.pageSize}
											total={pagination.total}
											onChange={this.handleMobilePageChange}
											showSizeChanger={false}
											simple
										/>
									</div>
								)}
							</div>
						) : (
							// ── Desktop: enhanced table ──
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey="id"
								scroll={{ x: 'max-content' }}
								size="middle"
								pagination={{
									current: pagination.current,
									pageSize: pagination.pageSize,
									total: pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total}`,
								}}
								onChange={this.handleTableChange}
							/>
						)}
					</div>
				</Card>

				{/* ── Modal Reset Password ── */}
				<Modal
					title={
						<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
							<KeyOutlined style={{ color: '#faad14' }} />
							Reset Password Pegawai
						</div>
					}
					visible={isModalVisible}
					onCancel={() => this.setState({ isModalVisible: false })}
					footer={null}
					style={{ top: 20 }}
					bodyStyle={{ padding: '20px 24px' }}
				>
					<Form layout="vertical" name="fdata" onFinish={this.handleSubmit} size="middle" className="no-uppercase">
						<Form.Item
							label="Password Baru"
							name="password"
							rules={[{ required: true, message: 'Password wajib diisi' }]}
							hasFeedback
						>
							<Input.Password
								placeholder="Masukkan password baru"
								style={{ borderRadius: 8 }}
							/>
						</Form.Item>
						<Form.Item
							label="Konfirmasi Password"
							name="confirm"
							dependencies={['password']}
							hasFeedback
							rules={[
								{ required: true, message: 'Konfirmasi password wajib diisi' },
								({ getFieldValue }) => ({
									validator(_, value) {
										if (!value || getFieldValue('password') === value) return Promise.resolve();
										return Promise.reject(new Error('Password tidak cocok!'));
									},
								}),
							]}
						>
							<Input.Password
								placeholder="Ulangi password baru"
								style={{ borderRadius: 8 }}
							/>
						</Form.Item>

						<Divider style={{ margin: '12px 0' }} />

						<Row justify="end" gutter={8}>
							<Col>
								<Button onClick={() => this.setState({ isModalVisible: false })} style={{ borderRadius: 8 }}>
									Batal
								</Button>
							</Col>
							<Col>
								<Button
									type="primary"
									htmlType="submit"
									icon={<CheckCircleOutlined />}
									loading={this.state.loadingButton}
									style={{ borderRadius: 8 }}
								>
									Simpan
								</Button>
							</Col>
						</Row>
					</Form>
				</Modal>
			</div>
		);
	}
}

const mapStateToProps = state => state.configReducers;

export default connect(
	mapStateToProps,
	{ initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(DataPegawai);
